<template>
  <v-container fluid>
    <!-- 店舗間定期配達登録ダイアログ { -->
    <v-card v-if="!displayConfirmDialog && !displayCompletedDialog" flat>
      <Form
        v-if="isWordListReady"
        v-slot="{ meta }"
       
      >
        <v-card flat>
          <!-- 登録タイトル -->
          <v-card-title
            v-if="!updateMode && !deleteMode"
            class="mb-3 text-h5 font-weight-bold"
          >
            {{ wordList.lbl_scheduled_delivery_regist }}
          </v-card-title>
          <!-- 変更タイトル -->
          <v-card-title
            v-else-if="updateMode"
            class="mb-3 text-h5 font-weight-bold"
          >
            {{ wordList.lbl_scheduled_delivery_edit }}
          </v-card-title>
          <v-card-text>
            <v-card flat class="pl-5 pt-3">
              <!-- チェーン名 -->
              <v-row class="mb-3">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_chain_name }}
                  </v-row>
                </v-col>
                <v-col cols="3">
                  {{ chain_name }}
                </v-col>
              </v-row>
              <!-- 出荷元 -->
              <v-row class="mb-4">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_shop_name_from }}
                  </v-row>
                </v-col>
                <v-col cols="2">
                  {{ shopData_from_name }}
                </v-col>
                <v-col cols="5" style="white-space: pre">
                  {{ shopData_from_address }}
                </v-col>
              </v-row>
              <!-- 配達先 -->
              <v-row class="mb-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_shop_name_to }}
                  </v-row>
                </v-col>
                <v-col cols="2">
                  {{ shopData_to_name }}
                </v-col>
                <v-col cols="5" style="white-space: pre">
                  {{ shopData_to_address }}
                </v-col>
              </v-row>
              <!-- お届け便選択 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_delivery_id }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="3" class="delivery-week-select">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_week"
                    v-model="deliveryIdSelectValues"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="deliveryIdSelectValues"
                      density="compact"
                      :items="deliveryIdItems"
                      item-title="label"
                      item-value="value"
                      clearable
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      :error-messages="errors"
                      multiple
                      variant="outlined"
                      return-object
                      @blur="handleBlur"
                      :menu-props="{
                        maxHeight: 410,
                        height: 410,
                      }"
                      @update:model-value="onChangeDeliveryIdSelect"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <v-col cols="3">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_id"
                    v-model="deliverySelectValues"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="deliverySelectValues"
                      density="compact"
                      :items="listDeliveryId"
                      item-title="delivery_name"
                      item-value="area_delivery_id"
                      :label="wordList.lbl_delivery_id"
                      :error-messages="errors"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      @blur="handleBlur"
                      @update:model-value="onChangeDeliveryId"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- 配達時間 -->
              <v-row v-if="delivery_time_input">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_delivery_time }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col class="flex-grow-0" style="flex: 0 0 12.5%; max-width: 12.5%;">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_irregular_delivery_start_time"
                    v-model="
                      scheduledDeliveryCreateInput.irregular_delivery_start_time
                    "
                    rules="required|time_format"
                  >
                    <v-text-field
                      v-model="
                        scheduledDeliveryCreateInput.irregular_delivery_start_time
                      "
                      variant="outlined"
                      density="compact"
                      :label="wordList.lbl_irregular_delivery_start_time"
                      :placeholder="wordList.plc_irregular_delivery_time"
                      :error-messages="errors"
                      @blur="handleBlur"
                      @change="onChangeDeliveryStartTime"
                    ></v-text-field>
                  </Field>
                </v-col>
                <p class="mt-6 mx-2 center">～</p>
                <v-col class="flex-grow-0" style="flex: 0 0 12.5%; max-width: 12.5%;">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_irregular_delivery_end_time"
                    v-model="
                      scheduledDeliveryCreateInput.irregular_delivery_end_time
                    "
                    rules="required|time_format"
                  >
                    <v-text-field
                      v-model="
                        scheduledDeliveryCreateInput.irregular_delivery_end_time
                      "
                      variant="outlined"
                      density="compact"
                      :label="wordList.lbl_irregular_delivery_end_time"
                      :placeholder="wordList.plc_irregular_delivery_time"
                      :error-messages="errors"
                      @blur="handleBlur"
                      @change="onChangeDeliveryEndTime"
                    ></v-text-field>
                  </Field>
                </v-col>
              </v-row>
              <v-row v-if="!delivery_time_input" class="mb-3">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_delivery_time }}
                  </v-row>
                </v-col>
                <v-col cols="3">
                  {{
                    scheduledDeliveryCreateInput.irregular_delivery_start_time
                  }}
                  ～
                  {{ scheduledDeliveryCreateInput.irregular_delivery_end_time }}
                </v-col>
              </v-row>
              <!-- 配達依頼作成日時 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3" justify="end">
                    {{ wordList.lbl_delivery_request_create }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col class="flex-grow-0" style="flex: 0 0 12.5%; max-width: 12.5%;">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_request_create_date"
                    v-model="deliveryRequestCreateDateValues"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="deliveryRequestCreateDateValues"
                      density="compact"
                      :items="deliveryRequestCreateDateItem"
                      item-title="label"
                      item-value="delivery_request_create_date"
                      :label="wordList.lbl_delivery_request_create_date"
                      :error-messages="errors"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      @blur="handleBlur"
                      @update:model-value="onChangeDeliveryRequestCreateDate"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <v-col class="flex-grow-0" style="flex: 0 0 12.5%; max-width: 12.5%;">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_request_create_time"
                    v-model="deliveryRequestCreateTimeValues"
                    rules="required"
                  >
                    <v-autocomplete
                      v-model="deliveryRequestCreateTimeValues"
                      density="compact"
                      :items="deliveryRequestCreateTimeItem"
                      item-title="delivery_request_create_time"
                      item-value="delivery_request_create_time"
                      :label="wordList.lbl_delivery_request_create_time"
                      :error-messages="errors"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      @blur="handleBlur"
                    ></v-autocomplete>
                  </Field>
                </v-col>
                <p class="mt-6 mx-2 center">時</p>
              </v-row>
              <!-- 定期配達有効期間 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15" justify="end">
                    {{ wordList.lbl_valid_date }}
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <v-menu
                    :close-on-content-click="false"
                    :offset="[40, 0]"
                    transition="scale-transition"
                    location="bottom"
                    min-width="auto"
                  >
                    <template #activator="{ props }">
                      <Field
                        v-slot="{ errors, handleBlur }"
                        :name="wordList.lbl_valid_date_from"
                        v-model="scheduledDeliveryCreateInput.valid_date_from"
                        rules="max:10"
                      >
                        <v-text-field
                          v-model="scheduledDeliveryCreateInput.valid_date_from"
                          variant="outlined"
                          density="compact"
                          :label="wordList.lbl_valid_date_from"
                          :placeholder="wordList.plc_valid_date"
                          readonly
                          clearable
                          v-bind="props"
                          :error-messages="errors"
                          bg-color="#fff"
                          @blur="handleBlur"
                        ></v-text-field>
                      </Field>
                    </template>
                    <v-locale-provider locale="ja" :messages="{ ja: vuetifyJa }">
                      <v-date-picker
                        v-datepicker-scroll
                        v-model="scheduledDeliveryCreateInput.valid_date_from"
                        hide-header
                        show-adjacent-months
                        view-mode="month"
                        @update:model-value="onChangeValidDateFrom"
                      >
                      </v-date-picker>
                    </v-locale-provider>
                  </v-menu>
                </v-col>
                <p class="mt-6 mx-2 center">〜</p>
                <v-col cols="2">
                  <v-menu
                    :close-on-content-click="false"
                    :offset="[40, 0]"
                    transition="scale-transition"
                    location="bottom"
                    min-width="auto"
                  >
                    <template #activator="{ props }">
                      <Field
                        v-slot="{ errors, handleBlur }"
                        :name="wordList.lbl_valid_date_to"
                        v-model="scheduledDeliveryCreateInput.valid_date_to"
                        rules="max:10"
                      >
                        <v-text-field
                          v-model="scheduledDeliveryCreateInput.valid_date_to"
                          variant="outlined"
                          density="compact"
                          :label="wordList.lbl_valid_date_to"
                          :placeholder="wordList.plc_valid_date"
                          readonly
                          clearable
                          v-bind="props"
                          :error-messages="errors"
                          bg-color="#fff"
                          @blur="handleBlur"
                        ></v-text-field>
                      </Field>
                    </template>
                    <v-locale-provider locale="ja" :messages="{ ja: vuetifyJa }">
                      <v-date-picker
                        v-datepicker-scroll
                        v-model="scheduledDeliveryCreateInput.valid_date_to"
                        hide-header
                        show-adjacent-months
                        view-mode="month"
                        @update:model-value="onChangeValidDateTo"
                      >
                      </v-date-picker>
                    </v-locale-provider>
                  </v-menu>
                </v-col>
              </v-row>
              <!-- 配達備考 -->
              <v-row>
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-10" justify="end">
                    {{ wordList.lbl_delivery_notes }}
                    <v-tooltip location="top">
                      <template #activator="{ props }">
                        <v-icon v-bind="props">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                      <span>DSSでは注文備考に連携されます。</span>
                    </v-tooltip>
                  </v-row>
                </v-col>
                <v-col cols="6" sm="6" md="6" lg="6">
                  <Field
                    v-slot="{ errors, handleBlur }"
                    :name="wordList.lbl_delivery_notes"
                    v-model="scheduledDeliveryCreateInput.delivery_notes"
                  >
                    <v-textarea
                      v-model="scheduledDeliveryCreateInput.delivery_notes"
                      variant="outlined"
                      density="compact"
                      :error-messages="errors"
                      :placeholder="wordList.plc_delivery_note"
                      @blur="handleBlur"
                    >
                    </v-textarea>
                  </Field>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-card-actions class="justify-center py-10">
            <!-- 店舗間定期配達登録へ戻るボタン -->
            <v-btn
              v-if="!updateMode && !deleteMode"
              variant="flat"
              color="return"
              class="px-16"
              @click="onClickInputCancel"
            >
              <v-icon>mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}
            </v-btn>
            <!-- 店舗間定期配達一覧へ戻るボタン -->
            <v-btn
              v-if="updateMode || deleteMode"
              variant="flat"
              color="return"
              class="px-16"
              @click="onClickBack"
            >
              <v-icon>mdi-arrow-left</v-icon>
              {{ wordList.btn_return }}
            </v-btn>
            <!-- 確認画面へボタン -->
            <v-btn
              variant="flat"
              color="primary"
              class="px-16"
              :disabled="!meta.valid || (!meta.dirty && !hasAttemptedConfirm)"
              @click="onClickOpenConfirmDialog"
            >
              <v-icon>mdi-playlist-edit</v-icon>
              <!-- 登録確認タイトル -->
              <span v-if="!updateMode && !deleteMode">
                {{ wordList.btn_regist_confirm }}
              </span>
              <!-- 変更確認タイトル -->
              <span v-else-if="updateMode">{{
                wordList.btn_edit_confirm
              }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </Form>
    </v-card>
    <!-- } 店舗間定期配達登録ダイアログ -->
    <!-- 店舗間定期配達登録確認ダイアログ { -->
    <v-card v-if="displayConfirmDialog" flat>
      <v-card flat>
        <!-- 登録確認タイトル -->
        <v-card-title
          v-if="!updateMode && !deleteMode"
          class="mt-3 text-h5 font-weight-bold"
        >
          {{ wordList.lbl_scheduled_delivery_regist_confirm }}
        </v-card-title>
        <!-- 変更確認タイトル -->
        <v-card-title
          v-else-if="updateMode"
          class="mb-3 text-h5 font-weight-bold"
        >
          {{ wordList.lbl_scheduled_delivery_edit_confirm }}
        </v-card-title>
        <!-- 削除確認タイトル -->
        <v-card-title v-else class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_scheduled_delivery_delete_confirm }}
        </v-card-title>
        <v-card-text style="min-height: 500px" class="pt-5 confirm-display-text">
          <!-- チェーン名 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-11 pl-2" justify="end">
                {{ wordList.lbl_chain_name }}
              </v-row>
            </v-col>
            <v-col cols="9">{{ chain_name }}</v-col>
          </v-row>
          <!-- 出荷元 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-11 pl-2" justify="end">
                {{ wordList.lbl_shop_name_from }}
              </v-row>
            </v-col>
            <v-col cols="2">{{ shopData_from_name }}</v-col>
            <v-col cols="7" style="white-space: pre">{{
              shopData_from_address
            }}</v-col>
          </v-row>
          <!-- 配達先 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-11 pl-2" justify="end">
                {{ wordList.lbl_shop_name_to }}
              </v-row>
            </v-col>
            <v-col cols="2">{{ shopData_to_name }}</v-col>
            <v-col cols="7" style="white-space: pre">{{
              shopData_to_address
            }}</v-col>
          </v-row>
          <!-- お届け便選択 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_id }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              <span v-for="item in deliveryIdSelectValues" :key="item.label">
                {{ item.label }}
              </span>
              <span v-if="deliverySelectValues?.delivery_id === 99">
                &nbsp;&nbsp;{{ deliverySelectValues.delivery_name }}
              </span>
              <span v-else-if="deliverySelectValues?.delivery_id !== undefined">
                &nbsp;&nbsp;{{ deliverySelectValues.delivery_name }}
              </span>
            </v-col>
          </v-row>
          <!-- 配達時間 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense v-if="delivery_time_input" class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_time }}
                <ImportantChip></ImportantChip>
              </v-row>
              <v-row align="center" dense v-if="!delivery_time_input" class="form-label-row mr-11 pl-2" justify="end">
                {{ wordList.lbl_delivery_time }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ scheduledDeliveryCreateInput.irregular_delivery_start_time }}
              ～
              {{ scheduledDeliveryCreateInput.irregular_delivery_end_time }}
            </v-col>
          </v-row>
          <!-- 配達依頼作成日時 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="py-2 pl-2" justify="end">
                {{ wordList.lbl_delivery_request_create }}
                <ImportantChip></ImportantChip>
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ deliveryRequestCreateDateValues.label }}&nbsp;&nbsp;
              {{ deliveryRequestCreateTimeValues }}時
            </v-col>
          </v-row>
          <!-- 定期配達有効期間 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-11 pl-2" justify="end">
                {{ wordList.lbl_valid_date }}
              </v-row>
            </v-col>
            <v-col
              v-if="
                (scheduledDeliveryCreateInput.valid_date_from !== undefined &&
                  scheduledDeliveryCreateInput.valid_date_from !== null &&
                  scheduledDeliveryCreateInput.valid_date_from !== '') ||
                (scheduledDeliveryCreateInput.valid_date_to !== undefined &&
                  scheduledDeliveryCreateInput.valid_date_to !== null &&
                  scheduledDeliveryCreateInput.valid_date_to !== '')
              "
              cols="9"
            >
              {{ scheduledDeliveryCreateInput.valid_date_from }} ～
              {{ scheduledDeliveryCreateInput.valid_date_to }}
            </v-col>
          </v-row>
          <!-- 配達備考 -->
          <v-row class="mb-3">
            <v-col cols="3" class="font-weight-black">
              <v-row align="center" dense class="form-label-row mr-11 pl-2" justify="end">
                {{ wordList.lbl_delivery_notes }}
              </v-row>
            </v-col>
            <v-col cols="9">
              {{ scheduledDeliveryCreateInput.delivery_notes }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <!-- 戻るボタン -->
          <v-btn
            variant="flat"
            color="return"
            class="px-16"
            @click="onClickConfirmCancel"
          >
            <v-icon>mdi-arrow-left</v-icon>
            {{ wordList.btn_return }}
          </v-btn>
          <!-- 完了画面ボタン -->
          <v-btn
            v-if="!deleteMode"
            variant="flat"
            color="primary"
            class="px-16"
            @click="onClickConfirmEntry"
          >
            <v-icon>mdi-playlist-edit</v-icon>
            <!-- 登録完了ボタン -->
            <span v-if="!updateMode && !deleteMode">
              {{ wordList.btn_regist_complete }}
            </span>
            <!-- 変更完了ボタン -->
            <span v-else-if="updateMode">
              {{ wordList.btn_edit_complete }}
            </span>
          </v-btn>
          <v-btn
            v-else
            variant="flat"
            color="primary"
            class="px-16"
            @click="onClickDelete"
          >
            <v-icon>mdi-playlist-edit</v-icon>
            <span>
              {{ wordList.btn_delete_complete }}
            </span>
          </v-btn>
        </v-card-actions>
        <v-overlay
          :model-value="overlay"
          class="d-flex align-center justify-center"
        >
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-card>
    </v-card>
    <!-- } 店舗間定期配達登録確認ダイアログ -->
    <!-- 店舗間定期配達登録完了ダイアログ { -->
    <v-card v-if="displayCompletedDialog" flat>
      <v-card flat>
        <v-card-title class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_scheduled_delivery_regist_complete }}
        </v-card-title>
        <v-card-text style="min-height: 500px">
          <v-row class="pt-5">
            <v-col class="font-weight-black">
              {{ wordList.lbl_scheduled_delivery_regist_complete_msg }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <!-- 戻るボタン -->
          <v-btn variant="flat" color="return" class="px-16" @click="onClickCompletedGoStart">
            <span>
              {{ wordList.btn_regist_return }}
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
    <!-- } 店舗間定期配達登録完了ダイアログ -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
  </v-container>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, max, regex } from "@vee-validate/rules";
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import { ja as vuetifyJa } from "vuetify/locale";

import { useScheduledDeliveryRegisterUiState } from "./composables/useScheduledDeliveryRegisterUiState";
import { useScheduledDeliveryRegisterForm } from "./composables/useScheduledDeliveryRegisterForm";
import { useScheduledDeliveryRegisterApi } from "./composables/useScheduledDeliveryRegisterApi";
import { useScheduledDeliveryRegisterInit } from "./composables/useScheduledDeliveryRegisterInit";
import { useScheduledDeliveryRegisterActions } from "./composables/useScheduledDeliveryRegisterActions";

defineRule("required", required);
defineRule("max", max);
defineRule("regex", regex);
defineRule("time_format", (value: unknown): true | string => {
  if (value === null || value === undefined || value === "") {
    return true;
  }
  const text = String(value);
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(text)
    || "時刻はhh:mm形式で入力してください。";
});
configure({
  generateMessage: localize({
    ja,
  }),
});

////////////////////////////////////////////////////////////////////////////////
// Composables
////////////////////////////////////////////////////////////////////////////////

const {
  errdialog,
  errMessage,
  updateMode,
  deleteMode,
  overlay,
  displayConfirmDialog,
  displayCompletedDialog,
  hasAttemptedConfirm,
} = useScheduledDeliveryRegisterUiState();

const {
  scheduledDeliveryCreateInput,
  scheduledDeliveryUpdateInput,
  shopListInput,
  deliveryTimeListInput,
  deliverableAreaDeliveryIdInput,
  operationInput,
  areaListItems,
  deliveryIdSelectValues,
  listDeliveryTime,
  deliverySelectValues,
  deliveryRequestCreateDateItem,
  deliveryRequestCreateDateValues,
  deliveryRequestCreateTimeItem,
  deliveryRequestCreateTimeValues,
  listDeliveryId,
  delivery_time_input,
  onChangeDeliveryIdSelect,
  onChangeDeliveryId,
  onChangeDeliveryStartTime,
  onChangeDeliveryEndTime,
  onChangeDeliveryRequestCreateDate,
  onChangeValidDateFrom,
  onChangeValidDateTo,
  SetdeliveryId,
  createDeliveryId,
  copyCreateToUpdate,
  allClear,
} = useScheduledDeliveryRegisterForm({ errdialog, errMessage });

const {
  getShopData,
  GetAreaData,
  queryDeliverytime,
  chkDeliveryId,
  getScheduledDelivery,
  createScheduledDelivery,
  updateScheduledDelivery,
  deleteScheduledDelivery,
} = useScheduledDeliveryRegisterApi({
  errdialog,
  errMessage,
  scheduledDeliveryCreateInput,
  scheduledDeliveryUpdateInput,
  operationInput,
  deliveryTimeListInput,
  deliverableAreaDeliveryIdInput,
  areaListItems,
  listDeliveryTime,
  listDeliveryId,
});

const {
  wordList,
  isWordListReady,
  chain_name,
  shopData_from_name,
  shopData_from_address,
  shopData_to_name,
  shopData_to_address,
  deliveryIdItems,
  runInitialLoad,
} = useScheduledDeliveryRegisterInit({
  errdialog,
  errMessage,
  overlay,
  updateMode,
  deleteMode,
  displayConfirmDialog,
  scheduledDeliveryCreateInput,
  shopListInput,
  deliveryTimeListInput,
  deliverableAreaDeliveryIdInput,
  deliveryIdSelectValues,
  deliverySelectValues,
  deliveryRequestCreateDateValues,
  deliveryRequestCreateTimeValues,
  listDeliveryId,
  deliveryRequestCreateDateItem,
  getShopData,
  GetAreaData,
  queryDeliverytime,
  chkDeliveryId,
  getScheduledDelivery,
  SetdeliveryId,
  onChangeDeliveryId,
  onChangeDeliveryRequestCreateDate,
});

const {
  onClickOpenConfirmDialog,
  onClickInputCancel,
  onClickBack,
  onClickConfirmEntry,
  onClickDelete,
  onClickConfirmCancel,
  onClickCompletedGoStart,
} = useScheduledDeliveryRegisterActions({
  overlay,
  updateMode,
  deleteMode,
  displayConfirmDialog,
  displayCompletedDialog,
  hasAttemptedConfirm,
  scheduledDeliveryCreateInput,
  deliverySelectValues,
  deliveryRequestCreateTimeValues,
  createDeliveryId,
  copyCreateToUpdate,
  allClear,
  createScheduledDelivery,
  updateScheduledDelivery,
  deleteScheduledDelivery,
});

////////////////////////////////////////////////////////////////////////////////
// 初期画面
////////////////////////////////////////////////////////////////////////////////
onMounted(async (): Promise<void> => {
  await runInitialLoad();
});
</script>

<style scoped>
/* お届け便選択の曜日セレクトボックス: 全曜日選択時にinput要素が幅を取って二行になる不具合を防止 */
.delivery-week-select :deep(.v-field__input > input) {
  width: 0;
  min-width: 0;
  padding: 0;
  position: absolute;
}
</style>
